import { useTranslations } from 'next-intl';
import carouselConfig from '@config/carouselConfig';

export const useOurServices = () => {
  const t = useTranslations('services');

  const translatedCarouselConfig = carouselConfig.map((item) => {
    const key = item.title
      .toLowerCase()
      .trim()
      .replace(/[^a-zA-Z0-9]/g, '')
      .replace(/\s+/g, '');

    return {
      ...item,
      title: t(`${key}.title`),
      description: t(`${key}.description`),
      details: t(`${key}.details`),
    };
  });

  return { t, translatedCarouselConfig };
};
